<template>
  <div class="sidebar-mobile" >
    <nav class="sidebar-mobile_nav">
      <ul class="sidebar-mobile_nav-list">
        <li class="sidebar-mobile_nav-list-nav-link">
          <router-link
            class="sidebar-mobile_nav-list-nav-link-route-link"
            :to="{ name: 'why-customers' }"
            >Why WR1</router-link
          >
        </li>
        <li class="sidebar-mobile_nav-list-nav-link">
          <router-link
            class="sidebar-mobile_nav-list-nav-link-route-link"
            to="/online-service"
            >Online Service
          </router-link>
        </li>
        <li class="sidebar-mobile_nav-list-nav-link">
          <router-link
            class="sidebar-mobile_nav-list-nav-link-route-link"
            :to="{ name: 'core-service-customers' }"
            >Core Service
          </router-link>
        </li>
        <li class="sidebar-mobile_nav-list-nav-link">
          <router-link
            class="sidebar-mobile_nav-list-nav-link-route-link"
            to="/earphones"
            >Blog</router-link
          >
        </li>
        <li class="sidebar-mobile_nav-list-nav-link">
          <router-link
            class="sidebar-mobile_nav-list-nav-link-route-link"
            to="/earphones"
            >Contact WR1</router-link
          >
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "SideBar",
};
</script>

<style lang="scss" scoped>
.sidebar-mobile {
  position: absolute;
  width: initial;
  left: 0px;
  right: 0px;
  z-index: 999;
  &_nav {
    background-color: #fff;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    &-list {
      list-style: none;
      padding: 0;
      margin: 0;
      text-align: center;
      &-nav-link {
        padding: 20px 30px;
        text-transform: capitalize;
        font-weight: 400;
        font-size: 1.1rem;
        cursor: pointer;
        line-height: 1.45;
        color: #2b938c;
        &-route-link {
          color: inherit;
        }

        .router-link-active {
          font-weight: 600;
        }
      }
    }
  }
}
</style>